var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "x-mark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8679 4.86627C12.1608 4.57337 12.1608 4.0985 11.8679 3.80561C11.575 3.51271 11.1002 3.51271 10.8073 3.80561L7.9376 6.67528L5.06793 3.80561C4.77503 3.51271 4.30016 3.51271 4.00727 3.80561C3.71437 4.0985 3.71437 4.57337 4.00727 4.86627L6.87694 7.73594L4.00727 10.6056C3.71437 10.8985 3.71437 11.3734 4.00727 11.6663C4.30016 11.9592 4.77503 11.9592 5.06793 11.6663L7.9376 8.7966L10.8073 11.6663C11.1002 11.9592 11.575 11.9592 11.8679 11.6663C12.1608 11.3734 12.1608 10.8985 11.8679 10.6056L8.99826 7.73594L11.8679 4.86627Z",
    fill: "#60636B"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXMark);
export default __webpack_public_path__ + "static/media/x-mark.1b323f1b91d514ab2583a4424f7ff432.svg";
export { ForwardRef as ReactComponent };